/**
 * Helper to determine if an error is a "Not Found" error, even if wrapped in a 500 status code
 * (legacy backend quirk).
 */
export function isNotFoundError(error: unknown): boolean {
  const err = error as { response?: { status?: number; data?: { detail?: unknown } } } | null | undefined;
  if (err?.response?.status === 404) return true;
  if (err?.response?.status === 500) {
    const detail = err.response?.data?.detail;
    if (typeof detail === 'string' && (detail.includes('404') || detail.includes('NotFoundError'))) {
      return true;
    }
  }
  return false;
}
